module.exports = __webpack_public_path__ + "static/img/u87.b40e9da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u87.png
// module id = 0/Su
// module chunks = 73